import React from "react";
import TextField from "../TextField";

import ShowIcon from "@tiny/icons/generated/Show";
import HideIcon from "@tiny/icons/generated/Hide";
import { PasswordFieldProps } from "./PasswordField.types";
import { useStyles } from "./PasswordField.styles";

function PasswordField(props: PasswordFieldProps): JSX.Element {
  const [show, setShow] = React.useState(false);

  const classes = useStyles();

  const handleIconClick = () => {
    setShow((v) => !v);
  };

  const endIcon = (
    <button
      className={classes.showButton}
      onClick={handleIconClick}
      title={show ? "Hide password" : "Show password"}
      type="button"
    >
      {show ? <HideIcon /> : <ShowIcon />}
    </button>
  );

  return (
    <TextField {...props} endIcon={endIcon} type={show ? "text" : "password"} />
  );
}

export default PasswordField;
